import React from "react";

const Link1 = () => {
  return <div className="link-1">Link 1</div>;
};

export default Link1;
